export default "__VITE_ASSET__FwYTM_Ec__"